import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* REST API */
import { filters } from "../../api/Message"

/* Helpers */
import { utils } from "../../helpers"

/* Icons */
import { CloseIcon, CheckIcon, SearchIcon, CalendarIcon, TableIcon, FilterIcon, InfoIcon, OperatorIcon, PlayerIcon } from "./MessageIcons"

/* Timezone — диапазоны строим в ВЫБРАННОЙ зоне, не в зоне машины */
import { nowInTz } from "../../helpers/timezone"

/* DatePicker */
import DatePicker, { registerLocale } from "react-datepicker"
import ru from "date-fns/locale/ru"

/* Sweet alert */
import Swal from "../../helpers/alert"

/* DatePicker Settings */
registerLocale("ru", ru)


/* THE INNER SEARCH APPEARS ONLY WHEN THE LIST OF GAMES IS LONG ENOUGH TO SCROLL */
const SEARCHABLE = 8


/* Widget Message Filter */
class Filter extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            selected: "all",
            start: null,
            end: null,
            operators: [],
            tables: [],
            testers: false,
            allOperators: [],
            allTables: [],
            search: "",
        }
    }

    /* Periods Of The Picker */
    getPeriods = () => [
        { key: "3hours", text: t("player.last3h") },
        { key: "6hours", text: t("player.last6h") },
        { key: "12hours", text: t("player.last12h") },
        { key: "today", text: t("player.today") },
        { key: "yesterday", text: t("player.yesterday") },
        { key: "7days", text: t("player.last7days") },
        { key: "14days", text: t("player.last14days") },
        { key: "30days", text: t("player.last30days") },
        { key: "month", text: t("player.thisMonth") },
        { key: "prevmonth", text: t("player.prevMonth") },
        { key: "all", text: t("player.allTime") },
    ]

    /* Open Action */
    open = ({ selected = "all", start = null, end = null, operators = [], tables = [], testers = true }) => {

        this.setState({
            visible: true,
            selected,
            start,
            end,
            operators: [...operators],
            tables: [...tables],
            testers,
            search: "",
        }, () => {
            this.load()
        })
    }

    /* Close Action */
    close = () => {
        this.setState({ visible: false })
    }

    /* Load Action — the operators and the games come strictly inside the scope of the token,
     * so no option of the filter can ever reach a foreign studio */
    load = () => {

        /* Check Loaded */
        if (this.state.allOperators.length > 0 || this.state.allTables.length > 0) {
            return
        }

        /* Send to REST API */
        filters().then((response) => {
            if (response.status === 200) {
                this.setState({ allOperators: response.data.operators, allTables: response.data.tables })
            }
        }).catch(() => {
            this.setState({ allOperators: [], allTables: [] })
        })

    }

    /* Games Of The Search */
    getTables = () => {

        /* Fields */
        const { allTables, search } = this.state
        const value = search.trim().toLowerCase()

        /* Check Search */
        if (value === "") {
            return allTables
        }

        /* Send Result */
        return allTables.filter((item) => {

            const name = String(utils.checkValue(item.name, "")).toLowerCase()
            const slug = String(utils.checkValue(item.slug, "")).toLowerCase()
            const studio = String(utils.checkValue(item.studioName, "")).toLowerCase()

            return name.includes(value) || slug.includes(value) || studio.includes(value)
        })
    }

    /* Check Game */
    checkTable = (table) => {
        return this.state.tables.findIndex((item) => parseInt(item.id) === parseInt(table.id)) > -1
    }

    /* Toggle Game */
    toggleTable = (table) => {

        /* Fields */
        const { tables } = this.state

        /* Get Index */
        const index = tables.findIndex((item) => parseInt(item.id) === parseInt(table.id))

        /* Check Index */
        if (index > -1) {
            tables.splice(index, 1)
        }
        else {
            tables.push(table)
        }

        this.setState({ tables })
    }

    /* Select Every Game Of The Search — an empty selection already means every game */
    selectTables = () => {
        this.setState({ tables: [...this.getTables()] })
    }

    /* Deselect Every Game */
    deselectTables = () => {
        this.setState({ tables: [] })
    }

    /* Check Operator */
    checkOperator = (operator) => {
        return this.state.operators.findIndex((item) => parseInt(item.id) === parseInt(operator.id)) > -1
    }

    /* Toggle Operator */
    toggleOperator = (operator) => {

        /* Fields */
        const { operators } = this.state

        /* Get Index */
        const index = operators.findIndex((item) => parseInt(item.id) === parseInt(operator.id))

        /* Check Index */
        if (index > -1) {
            operators.splice(index, 1)
        }
        else {
            operators.push(operator)
        }

        this.setState({ operators })
    }

    /* Select Every Operator */
    selectOperators = () => {
        this.setState({ operators: [...this.state.allOperators] })
    }

    /* Deselect Every Operator */
    deselectOperators = () => {
        this.setState({ operators: [] })
    }

    /* Select Period */
    select = (selected) => {

        /* All Period — no border goes to the request */
        if (selected === "all") {
            this.setState({ start: null, end: null, selected })
            return
        }

        /* Hours */
        const hours = { "3hours": 3, "6hours": 6, "12hours": 12 }

        if (hours[selected]) {
            this.setState({ start: nowInTz().subtract(hours[selected], "hours").toDate(), end: nowInTz().toDate(), selected })
            return
        }

        /* Today */
        if (selected === "today") {
            this.setState({ start: nowInTz().startOf("day").toDate(), end: nowInTz().endOf("day").toDate(), selected })
            return
        }

        /* Yesterday */
        if (selected === "yesterday") {
            this.setState({
                start: nowInTz().subtract(1, "day").startOf("day").toDate(),
                end: nowInTz().subtract(1, "day").endOf("day").toDate(),
                selected,
            })
            return
        }

        /* Days */
        const days = { "7days": 6, "14days": 13, "30days": 29 }

        if (days[selected] !== undefined) {
            this.setState({ start: nowInTz().subtract(days[selected], "days").startOf("day").toDate(), end: nowInTz().endOf("day").toDate(), selected })
            return
        }

        /* This Month */
        if (selected === "month") {
            this.setState({ start: nowInTz().startOf("month").toDate(), end: nowInTz().endOf("month").toDate(), selected })
            return
        }

        /* Previous Month */
        if (selected === "prevmonth") {
            this.setState({
                start: nowInTz().subtract(1, "month").startOf("month").toDate(),
                end: nowInTz().subtract(1, "month").endOf("month").toDate(),
                selected,
            })
        }

    }

    /* Reset Action */
    reset = () => {
        this.setState({ selected: "all", start: null, end: null, operators: [], tables: [], testers: true, search: "" })
    }

    /* Apply Action */
    apply = () => {

        /* Fields */
        const { selected, start, end, operators, tables, testers } = this.state
        const { apply } = this.props

        /* Check Dates */
        if (selected !== "all" && (!start || !end)) {
            Swal.fire(utils.notification(t("filter.selectDates"), "error", 2000))
            return
        }

        /* Set Apply */
        apply({ selected, start, end, operators, tables, testers })

        /* Close Modal */
        this.close()
    }

    /* Draw Period */
    _period = () => {

        /* Fields */
        const { selected, start, end } = this.state

        return (
            <div className="msg--section">

                <div className="msg--section-head">
                    <div className="msg--section-title">
                        <CalendarIcon />
                        {t("msg.period")}
                    </div>
                </div>

                <div className="msg--chips">
                    {this.getPeriods().map((item, index) =>
                        <div
                            onClick={() => this.select(item.key)}
                            className={`msg--chip ${selected === item.key ? "active" : ""}`}
                            key={`${index}`}
                        >
                            {item.text}
                        </div>
                    )}
                </div>

                <div className="msg--range">

                    <DatePicker
                        selected={start}
                        onChange={(date) => this.setState({ start: date, selected: "period" })}
                        selectsStart
                        startDate={start}
                        endDate={end}
                        maxDate={end}
                        dateFormat="dd.MM.yyyy HH:mm"
                        locale="ru"
                        showTimeSelect
                        placeholderText={t("msg.dateFrom")}
                    />

                    <DatePicker
                        selected={end}
                        onChange={(date) => this.setState({ end: date, selected: "period" })}
                        selectsEnd
                        startDate={start}
                        endDate={end}
                        minDate={start}
                        dateFormat="dd.MM.yyyy HH:mm"
                        locale="ru"
                        showTimeSelect
                        placeholderText={t("msg.dateTo")}
                    />

                </div>

            </div>
        )
    }

    /* Draw Players — the test accounts are inside the list until they are dropped */
    _players = () => {

        /* Fields */
        const { testers } = this.state

        return (
            <div className="msg--section">

                <div className="msg--section-head">
                    <div className="msg--section-title">
                        <PlayerIcon />
                        {t("msg.players")}
                    </div>
                </div>

                <div className="msg--chips">

                    <div onClick={() => this.setState({ testers: !testers })} className={`msg--check ${testers ? "active" : ""}`}>
                        <div className="msg--check-box">{testers && <CheckIcon size={11} />}</div>
                        <span>{t("msg.includeTesters")}</span>
                    </div>

                </div>

            </div>
        )
    }

    /* Draw Operators — a scope with a single operator has nothing to choose from */
    _operators = () => {

        /* Fields */
        const { allOperators, operators } = this.state

        /* Check Operators */
        if (allOperators.length < 2) {
            return null
        }

        return (
            <div className="msg--section">

                <div className="msg--section-head">

                    <div className="msg--section-title">
                        <OperatorIcon />
                        {t("msg.operators")}
                        <span className={`msg--counter ${operators.length === 0 ? "empty" : ""}`}>{operators.length}</span>
                    </div>

                    <div className="msg--section-actions">
                        <span onClick={() => this.selectOperators()}>{t("filter.selectAll")}</span>
                        <span onClick={() => this.deselectOperators()}>{t("filter.deselectAll")}</span>
                    </div>

                </div>

                <div className="msg--chips">
                    {allOperators.map((item, index) =>
                        <div
                            onClick={() => this.toggleOperator(item)}
                            className={`msg--chip ${this.checkOperator(item) ? "active" : ""}`}
                            key={`${index}`}
                        >
                            {item.name}
                        </div>
                    )}
                </div>

            </div>
        )
    }

    /* Draw Games */
    _tables = () => {

        /* Fields */
        const { allTables, tables, search } = this.state
        const list = this.getTables()

        return (
            <div className="msg--section">

                <div className="msg--section-head">

                    <div className="msg--section-title">
                        <TableIcon />
                        {t("msg.games")}
                        <span className={`msg--counter ${tables.length === 0 ? "empty" : ""}`}>{tables.length}</span>
                    </div>

                    <div className="msg--section-actions">
                        <span onClick={() => this.selectTables()}>{t("filter.selectAll")}</span>
                        <span onClick={() => this.deselectTables()}>{t("filter.deselectAll")}</span>
                    </div>

                </div>

                {allTables.length > SEARCHABLE &&
                    <div className="msg--inner-search">
                        <SearchIcon size={14} />
                        <input value={search} onChange={(event) => this.setState({ search: event.target.value })} placeholder={t("msg.searchByGame")} />
                        {search !== "" &&
                            <div onClick={() => this.setState({ search: "" })} className="msg--inner-search-clear">
                                <CloseIcon size={11} />
                            </div>
                        }
                    </div>
                }

                {list.length === 0 &&
                    <div className="msg--chips-empty">{search !== "" ? t("msg.nothingFound") : t("msg.gamesEmpty")}</div>
                }

                <div className="msg--tables">
                    {list.map((item, index) =>
                        <div
                            onClick={() => this.toggleTable(item)}
                            className={`msg--table-chip ${this.checkTable(item) ? "active" : ""}`}
                            key={`${index}`}
                        >

                            <div className="msg--table-box">{this.checkTable(item) && <CheckIcon size={11} />}</div>

                            <div className="msg--table-text">
                                <div className="msg--table-name">{utils.checkValue(item.name, item.slug)}</div>
                                <div className="msg--table-note">{utils.checkValue(item.studioName, item.slug)}</div>
                            </div>

                        </div>
                    )}
                </div>

                <div className="msg--hint">
                    <InfoIcon />
                    <span>{t("msg.filterHint")}</span>
                </div>

            </div>
        )
    }

    render = () => {

        /* Fields */
        const { visible } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.close()}
                className="msg--modal"
                overlayClassName="msg--overlay"
                closeTimeoutMS={200}
            >

                <div className="msg--modal-header">

                    <div className="msg--modal-icon">
                        <FilterIcon size={18} />
                    </div>

                    <div className="msg--modal-head-text">
                        <h2>{t("msg.filterTitle")}</h2>
                        <p>{t("msg.filterSubtitle")}</p>
                    </div>

                    <div onClick={() => this.close()} className="msg--modal-close">
                        <CloseIcon />
                    </div>

                </div>

                <div className="msg--modal-body">

                    {/* Draw Period */}
                    {this._period()}

                    {/* Draw Players */}
                    {this._players()}

                    {/* Draw Operators */}
                    {this._operators()}

                    {/* Draw Games */}
                    {this._tables()}

                </div>

                <div className="msg--modal-footer space">

                    <div onClick={() => this.reset()} className="msg--button ghost">{t("msg.reset")}</div>

                    <div className="msg--modal-footer-right">
                        <div onClick={() => this.close()} className="msg--button ghost">{t("filter.cancel")}</div>
                        <div onClick={() => this.apply()} className="msg--button primary">{t("filter.apply")}</div>
                    </div>

                </div>

            </Modal>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(Filter)
